module.exports = __webpack_public_path__ + "img/top.35ffda1b.png";